import eAdminUserRole from "~/enums/eAdminUserRole"

export const accessOptions = [
  {
    name: "Admin",
    description: "Has access to everything",
    value: eAdminUserRole.Admin,
  },
  {
    name: "Manager",
    description: "Has access to everything except the ability to edit settings (things like prices, contact info, etc)",
    value: eAdminUserRole.Manager,
  },
  {
    name: "User",
    description: "Can manage all reservations/check-ins but cannot edit settings or access the stats tab to see macro financial data",
    value: eAdminUserRole.User,
  },
  {
    name: "User (no refund)",
    description: "Has the same permissions as the User level, but can not issue refunds",
    value: eAdminUserRole.UserNoRefund,
  },
  {
    name: "View Only",
    description: "The most restricted permission level. Like the User, cannot edit settings or access the stats tab, also but cannot create reservations, take payments, or issue refunds. Can only see reservations and manage check-ins",
    value: eAdminUserRole.ViewOnly,
  },
]
